<template>
  <div class="videoItem">
    <div class="item" v-if="value">
      <img src="@/assets/image/Information/icon_video.webp" class="icon" />
      <div class="info">
        <div class="title line-clamp-1">{{ name }}</div>
        <div class="size">{{ size | formatBytes }}</div>
      </div>
      <div class="setting">
        <span class="text" @click="showVideo">预览</span>
        <span class="solid">｜</span>
        <span class="text" @click="onClear">删除</span>
      </div>
    </div>
    <el-upload
      action=""
      v-else
      :auto-upload="false"
      accept="video/*"
      :limit="1"
      :show-file-list="false"
      :on-change="onChange"
      ref="uploadRef"
    >
      <div class="item pointer" style="border-style: dashed;color: #0062ff;justify-content: center;">
        <!-- <img src="@/assets/image/Information/icon_video.webp" class="icon" />-->
         <i class="el-icon-upload2"></i> 
        <div style="margin-left: 8px" class="def">点击上传</div>
      </div>
    </el-upload>
    <transition name="el-zoom-in-bottom">
      <div class="progress" v-show="progressPercent > 0">
        <el-progress :show-text="false" :percentage="progressPercent"></el-progress>
      </div>
    </transition>
    <VideoDialog ref="VideoDialogRef"/>
  </div>
</template>

<script>
import uploadFile from "@/utils/oss.js"; // 引入oss.js文件
import VideoDialog from '@/components/VideoDialog/index.vue';
export default {
  components: {
    VideoDialog
  },
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      name: "",
      size: "",
      progressPercent: 0,
    };
  },
  created() {},
  computed: {},
  methods: {
        showVideo() {
      this.$refs.VideoDialogRef.showVideo(this.value);
    },
    onClear() {
      this.$emit("input", "");
      this.name = "";
      this.size = "";
    },
    onInput(value) {
      this.$emit("input", value);
    },
    onProgress(res) {
      if (res) {
        this.progressPercent = res;
      }
    },
    async onChange(file) {
      try {
        this.progressPercent = 5;
        const { data } = await this.$api.getFileSts();
        const response = await uploadFile(
          file.raw,
          data,
          "znsign/avatar",
          this.onProgress
        );
        if (response.res.status !== 200) {
          this.$message({
            type: "error",
            message: "上传失败，请联系管理员",
          });
          return;
        }
        this.onInput(this.$oss + response.name);
        this.name = file.name;
        this.size = file.size;
      } finally {
        console.log("finally");
        setTimeout(() => {
          this.progressPercent = 0;
        }, 500);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.videoItem {
  position: relative;

  .item {
    background: #f9fbff;

    box-sizing: border-box;
    border: 1px solid #dce9fd;
    width: 400px;
    height: 78px;
    display: flex;
    align-items: center;
    padding: 0 20px;
    border-radius: 4px;
    .icon {
      width: 38px;
      height: 38px;
    }
    .info {
      margin-left: 8px;
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      height: 38px;
      .title {
        font-size: 14px;
        font-weight: normal;
        line-height: normal;
        color: #262626;
        width: 240px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .size {
        color: #999999;
        font-size: 12px;
        font-weight: normal;
        line-height: normal;
      }
    }
    .setting {
      color: #999999;
      font-size: 12px;
      font-weight: normal;
      line-height: normal;
      .text {
        cursor: pointer;
        &:hover {
          color: #0062ff;
        }
      }
      .solid {
        color: #eeeeee;
      }
    }
    .def {
      &:hover {
        color: #0062ff;
      }
    }
  }
  .progress {
    position: absolute;
    bottom: 0;
    width: 400px;
    z-index: 3;
  }
}
</style>
